import React, { useState } from 'react'
import { useDispatch } from 'react-redux'
import axios from 'axios'
import { Form } from 'react-bootstrap'

import { emailFormatIsValid } from '../../../functions/validation'
import { userIsPortalAdmin, userCanSeeAllRoutes } from '../../../functions/userPermissions'
import { handleErrorAndGenerateMessage } from '../../../functions/errorHandling'
import { getServerUrl } from '../../../functions/getServerUrl'

import InfoIconOverlay from '../../../components/InfoIconOverlay'
import LoaderButton from '../../../components/LoaderButton'

const AddUser = (props) => {
  const { currentUser } = props
  const dispatch = useDispatch()

  const initialState = {
    first_name: "",
    last_name: "",
    username: "",
    email: "",
    role: "",
    sites: [],
    region: "",
    usernameIsValid: false,
    usernameIsInvalid: false,
    emailIsValid: false,
    emailIsInvalid: false,
    invalidEmailMessage: '',
    savingUser: false,
  }

  
  const [state, updateState] = useState(initialState)
  
  const setState = (newState) => {
    return updateState(prevState => {
      return {
        ...prevState,
        ...newState
      }
    })
  }
  
  const handleChange = (e) => setState({ [e.target.name]: e.target.value })
  
  const {
    first_name,
    last_name,
    username,
    email,
    role,
    sites,
    region, 
    usernameIsValid,
    usernameIsInvalid,
    emailIsValid,
    emailIsInvalid,
    invalidEmailMessage,
    savingUser,
  } = state
  
  const userCanAddAdminsAndPharmaVigilance = !userIsPortalAdmin(currentUser) || !userCanSeeAllRoutes(currentUser)


  const handleRoleChange = (e) => {
    const newRole = e.target.value

    // Both of the conditionals below account for the different ways that user associations to sites are made based on the user role. The new user's Sites are reset to empty if one of the conditions is met
    if ((newRole === "Study Coordinator" || newRole === "Investigator or Co-Investigator") && (state.role === "Portal Admin" || state.role === "Pharmacovigilance")) {
      return setState({ role: newRole, sites: [], region: '' })
    }

    // if ((state.role === "Study Coordinator" || state.role === "Investigator or Co-Investigator") && (newRole === "Portal Admin" || newRole === "Pharmacovigilance")) {
    //   return setState({ role: newRole, sites: [], region: '' })
    // }

    if (newRole === "Portal Admin" || newRole === "Pharmacovigilance") {
      setState({ role: newRole, sites: [], region: '' })
      return getAllSitesForRegion(currentUser.region)
    }

    return handleChange(e)
  }



  const getAllSitesForRegion = (selectedRegion) => {
    if (selectedRegion) {
      setState({ savingUser: true })
      axios({
        method: "GET",
        url: `${getServerUrl()}/sites/region/`,
        headers: { "Authorization": "JWT " + localStorage.getItem("jwt") },
        params: { region: selectedRegion }
      })
      .then(response => {
        if (!response || !Array.isArray(response.data) || response.data.length === 0) {
          throw response
        }
        return setState({
          sites: response.data,
          savingUser: false,
        })
      })
      .catch(error => {
        // const currentUserSitesByRegion = currentUser.sites.filter(site => site.region === selectedRegion).map(filteredSite => filteredSite.url)
        // return setState({ sites: currentUserSitesByRegion, savingUser: false })

        const message = handleErrorAndGenerateMessage(error, 'retrieving the sites', dispatch)
        if (props && props.alert && props.alert.show && message) {
          props.alert.show(message)
        }

        return setState({
          sites: [],
          savingUser: false,
        })
      })
    }
  }



  // const handleRegionChange = (e) => {
  //   handleChange(e)
  //   // const selectedRegion = e.target.value
  //   getAllSitesForRegion(e.target.value)
  //   // if (selectedRegion) {
  //   //   setState({ savingUser: true })
  //   //   axios({
  //   //     method: "GET",
  //   //     url: `${getServerUrl()}/sites/region/`,
  //   //     headers: { "Authorization": "JWT " + localStorage.getItem("jwt") },
  //   //     params: { region: selectedRegion }
  //   //   })
  //   //   .then(response => {
  //   //     if (!response || !Array.isArray(response.data) || response.data.length === 0) {
  //   //       throw response
  //   //     }
  //   //     return setState({
  //   //       sites: response.data,
  //   //       savingUser: false,
  //   //     })
  //   //   })
  //   //   .catch(error => {
  //   //     // const currentUserSitesByRegion = currentUser.sites.filter(site => site.region === selectedRegion).map(filteredSite => filteredSite.url)
  //   //     // return setState({ sites: currentUserSitesByRegion, savingUser: false })
  //   //     return setState({
  //   //       sites: [],
  //   //       savingUser: false,
  //   //     })
  //   //   })
  //   // } else {
  //   //   return setState({
  //   //     sites: [],
  //   //     savingUser: false,
  //   //   })
  //   // }
  // }



  const verifyUsername = () => {

    if (!username) {
      return setState({
        usernameIsValid: false,
        usernameIsInvalid: false,
      })
    }

    axios({
      method:"GET",
      url:`${getServerUrl()}/users/verify_username/`,
      headers:{"Authorization": "JWT " + localStorage.getItem("jwt")},
      params: { username }
    })
    .then(response => {
      return setState({
        usernameIsValid: true,
        usernameIsInvalid: false,
      })
    })
    .catch(error => {
      if (error.response && error.response.status && error.response.status === 409) {
        return setState({
          usernameIsValid: false,
          usernameIsInvalid: true,
        })
      }

      const message = handleErrorAndGenerateMessage(error, 'verifying the uniqueness of the username', dispatch)
      if (props && props.alert && props.alert.show && message) {
        props.alert.show(message)
      }
      
    })
  }


  const verifyEmail = () => {
    if (!email) {
      return setState({
        emailIsValid: false,
        emailIsInvalid: false,
        invalidEmailMessage: '',
      })
    }

    if (emailFormatIsValid(email) === false) {
      return setState({
        emailIsValid: false,
        emailIsInvalid: true,
        invalidEmailMessage: 'Please enter a valid email address',
      })
    }

    axios({
      method:"GET",
      url:`${getServerUrl()}/users/verify_email/`,
      headers:{"Authorization": "JWT " + localStorage.getItem("jwt")},
      params: { email }
    })
    .then(response => {
      return setState({
        emailIsValid: true,
        emailIsInvalid: false,
        invalidEmailMessage: '',
      })
    })
    .catch(error => {
      if (error.response && error.response.status && error.response.status === 409) {
        return setState({
          emailIsValid: false,
          emailIsInvalid: true,
          invalidEmailMessage: 'Email is alredy in use. Please enter a different email address.',
        })
      }

      const message = handleErrorAndGenerateMessage(error, 'verifying the uniqueness of the email address', dispatch)
      if (props && props.alert && props.alert.show && message) {
        props.alert.show(message)
      }
    })
  }

  const createUser = () => {
    if (savingUser) {
      return
    }

    let message = ''

    if (!first_name || !last_name || !username || !email || !role) {
      message = "Please fill in all required fields"
    // } else if (sites.length < 1) {
    //   message = 'A user must be associated to at least one trial site'
    } else if ((usernameIsInvalid || !username) && (emailIsInvalid || !email)) {
      message = 'Username and email are not valid'
    } else if (usernameIsInvalid || !username) {
      message = 'Username is not valid'
    } else if (emailIsInvalid || !email) {
      message = 'Email is not valid'
    }

    if (message) {
      return props.alert.show(message)
    }

    setState({savingUser: true})

    const userPermissions = createUserPermissions(role)

    // set user region for database splitting. backend expects it to be lower case. US is the 'default' region/database in the django backend

    let userRegion
    if (region) {
      userRegion = region.toLowerCase()
    } else if (sites[0] && sites[0].region) {
      userRegion = sites[0].region.toLowerCase()
    } else {
      userRegion = currentUser.region.toLowerCase()
    }

    if (userRegion === 'us') {
      userRegion = 'default'
    } 

    const newUser = {
      first_name,
      last_name,
      username,
      email,
      role,
      sites: sites.map(site => site.id),
      region: userRegion,
      ...userPermissions,
      notify_new_user: true,
    }

    axios({
      method:"POST",
      url:`${getServerUrl()}/users/`,
      headers: { "Authorization": "JWT " + localStorage.getItem("jwt") },
      data: newUser,
    })
    .then(response => {
      props.alert.show('The user has been added. An email with login instructions will be sent to the email address provided', { type: 'success' })
      setState(initialState)
    })
    .catch(error => {
      setState({ savingUser: false })
      let message
      if (error?.response?.status === 401) {
        return handleErrorAndGenerateMessage(error, 'creating the user', dispatch)
      }

      if (props && props.alert && props.alert.show && message) {
        props.alert.show(message)
      }
      if (error.response && error.response.data && error.response.data.detail) {
        message = error.response.data.detail
      } else {
        message = "There was an error creating the user"
      }
      return props.alert.show(message)
    })
  }

  const compareSites = (a, b) => {
    if (`${a.region} - ${a.name}` > `${b.region} - ${b.name}`) {
      return 1
    }

    if (`${a.region} - ${a.name}` < `${b.region} - ${b.name}`) {
      return -1
    }

    return 0
  }

  return (
    <div id="AddUsers">
      <Form>
        <Form.Label>First name</Form.Label>
        <Form.Control
          onChange={handleChange}
          required
          type="text"
          placeholder="First name"
          value={first_name}
          name="first_name"
        />
      </Form>

      <br/>

      <Form>
        <Form.Label>Last name</Form.Label>
        <Form.Control
          onChange={handleChange}
          required
          type="text"
          placeholder="Last name"
          value={last_name}
          name="last_name"
        />
      </Form>

      <br/>

      <Form noValidate>
        <Form.Label>Username</Form.Label>
        <Form.Control
          onBlur={verifyUsername}
          onChange={handleChange}
          required
          type="text"
          placeholder="Username"
          value={username}
          name="username"
          isValid={usernameIsValid}
          isInvalid={usernameIsInvalid}
        />
        <Form.Control.Feedback type="invalid">
          Username is alredy in use. Please enter a different username.
        </Form.Control.Feedback>
      </Form>

      <br/>

      <Form noValidate>
        <Form.Label>Email</Form.Label>
        <Form.Control
          onBlur={verifyEmail}
          onChange={handleChange}
          required
          type="text"
          placeholder="Email"
          value={email}
          name="email"
          isValid={emailIsValid}
          isInvalid={emailIsInvalid}
        />
        <Form.Control.Feedback type="invalid">
          {invalidEmailMessage}
        </Form.Control.Feedback>
      </Form>

      <br/>

      <Form noValidate>
        <Form.Label>Role</Form.Label>
        <InfoIconOverlay
          text={
            <>
              <p>
                STUDY COORDINATOR: Can create new charts and work on incomplete charts
              </p>
              <p>
                INVESTIGATOR or CO-INVESTIGATOR: Can create new charts, work on incomplete charts, and review completed charts. Co-investigators can also add new users to the portal.
              </p>
              {userCanAddAdminsAndPharmaVigilance ?
                <>
                  <p>
                    PORTAL ADMIN: Can view everything except charts
                  </p>
                  <p>
                    PHARMACOVIGILANCE: Can only view adverse drug reactions
                  </p>
                </>
                :
                null
              }
            </>
          }
        />
        <Form.Control
          onChange={handleRoleChange}
          required
          as="select"
          value={role}
          name="role"
        >
          <option value="">Select Role</option>
          <option value="Study Coordinator">Study Coordinator</option>
          <option value="Investigator or Co-Investigator">Investigator or Co-Investigator</option>
          {userCanAddAdminsAndPharmaVigilance ?
            <>
              <option value="Portal Admin">Portal Admin</option>
              <option value="Pharmacovigilance">Pharmacovigilance</option>
            </>
            :
            null
          }
        </Form.Control>

        {role && (role === "Study Coordinator" || role === "Investigator or Co-Investigator") && Array.isArray(currentUser.sites) ?
          <>
            <br/>
            <Form.Label>Trial Site</Form.Label>
            <Form.Control
              onChange={(e) => {
                const selectedSite = currentUser.sites.find(site => site.id === e.target.value)
                return setState({ sites: [selectedSite] })
              }}
              required
              as="select"
              value={sites[0] && sites[0].id ? sites[0].id : ''}
              name="sites"
            >
              <option value="">Select Trial Site</option>
              {currentUser.sites.sort(compareSites).map(site => {
                return (
                  <option 
                    key={site.id}
                    value={site.id}
                  >
                    {site.region} - {site.name}
                  </option>
                )})
              }
            </Form.Control>
          </>
          :
          null
        }

        {/* {userCanSeeAllRoutes(currentUser) ?
          <>
            <br/>
            <Form.Label>Region</Form.Label>
            <InfoIconOverlay
              text='This selection will grant the new user access to data from all trial sites in the selected region'
            />
            <Form.Control
              onChange={handleRegionChange}
              required
              as="select"
              value={region}
              name="region"
            >
              <option value="">Select Region</option>
              <option value="EU">EU</option>
              <option value="US">US</option>
            </Form.Control>
          </>
          :
          null
        } */}
      </Form>

      <br/>

      <LoaderButton
        onClick={createUser}
        loading={savingUser}
        buttonText='Create User'
      />

    </div>
  )
}

export default AddUser




const createUserPermissions = (role) => {
  switch (role) {
    case 'Study Coordinator':
      return {
        is_chart_reviewer: false,
        is_site_admin: false,
        is_study_admin: false,
        is_pharma_vigilance: false,
        is_chart_creator: true,
      }
    case 'Investigator or Co-Investigator':
      return {
        is_chart_reviewer: true,
        is_site_admin: true,
        is_study_admin: false,
        is_pharma_vigilance: false,
        is_chart_creator: true,
      }
    case 'Portal Admin':
      return {
        is_chart_reviewer: false,
        is_site_admin: true,
        is_study_admin: true,
        is_pharma_vigilance: true,
        is_chart_creator: false,
      }
    case 'Pharmacovigilance':
      return {
        is_chart_reviewer: false,
        is_site_admin: false,
        is_study_admin: false,
        is_pharma_vigilance: true,
        is_chart_creator: false,
      }
    default:
      return {
        is_chart_reviewer: false,
        is_site_admin: false,
        is_study_admin: false,
        is_pharma_vigilance: false,
        is_chart_creator: false,
      }
  }
}
